import { toast } from 'components';
import i18n from 'i18n';
import fetch from '../../utils/fetch';

export function error(error) {
  return {
    type: 'INVOICE_LIST_ERROR', error,
  };
}

export function loading(loading) {
  return {
    type: 'INVOICE_LIST_LOADING', loading,
  };
}

export function success(data, append = false) {
  return {
    type: 'INVOICE_LIST_SUCCESS',
    data,
    append,
  };
}

export function list(page = '/invoices', append = true) {
  return (dispatch) => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response => response.json())
      .then((data) => {
        dispatch(loading(false));
        dispatch(success(data, append));

        if (data['hydra:view'] && data['hydra:view']['hydra:next']) {
          dispatch(list(data['hydra:view']['hydra:next'], append));
        }
      })
      .catch((e) => {
        toast.error(i18n.t('toastError'));
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return {
    type: 'INVOICE_LIST_RESET',
  };
}
